import { render } from "./Overview.vue?vue&type=template&id=53565a38&scoped=true"
import script from "@/assets/projectJs/Overview.js?vue&type=script&lang=js"
export * from "@/assets/projectJs/Overview.js?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=53565a38&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53565a38"]])

export default __exports__